import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en'],

  // Always fall back to English regardless of the URL
  defaultLocale: 'en',

  // Keeps URLs clean by avoiding the /en prefix
  localePrefix: 'never',
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
